import { removeClass } from '@opten/dom/remove-class';

export class FormExtendedOptions {
    selectors: {
        checkboxAccept?: string;
        dropzone?: string;
    };
}

declare const Dropzone;

export class FormExtended {
    private wrapperElement: HTMLElement;
    private dropzoneWrappers: Array<Element>;
    private dropzones: Array<any>;
    private _options: FormExtendedOptions = {
        selectors: {
            dropzone: 'js-c-form__field__dropzone'
        }
    };

    constructor(private wrapper: HTMLElement, options?: FormExtendedOptions) {
        this.wrapperElement = wrapper;
        this._options = { ...this._options, ...options };

        this.init();
    }

    private init() {
        this.dropzoneWrappers = Array.from(
            this.wrapperElement.getElementsByClassName(
                this._options.selectors.dropzone
            )
        );
        if (this.dropzoneWrappers) {
            this.dropzoneWrappers.forEach(o =>
                this.initFileUpload(o as HTMLElement)
            );
        }
    }

    private initFileUpload(element: HTMLElement) {
        const button = Array.from(
            element.getElementsByClassName(
                ' js-c-form__field__dropzone__button'
            )
        );
        if (button != null && button.length > 0) {
            button[0].addEventListener('change', event => {
                const target = event.target as HTMLInputElement;
                const files = target.files;
                // let file_names = [];
                const template = element.getElementsByClassName(
                    'js-c-form__field__dropzone__preview__item__template'
                )[0];
                const previewTemplate = template.innerHTML;
                const previewsContainer = element.getElementsByClassName(
                    'c-form__field__dropzone__preview__wrapper'
                )[0];
                previewsContainer.innerHTML = '';
                for (let i = 0; i < files.length; i++) {
                    // file_names.push(files[i].name);

                    let fileItem = previewTemplate.replace(
                        '{js-c-form__field__dropzone__preview__item__name}',
                        files[i].name
                    );
                    fileItem = fileItem.replace(
                        '{js-c-form__field__dropzone__preview__item__error}',
                        ''
                    ); // todo validate error

                    previewsContainer.innerHTML += fileItem;
                }
            });
        }
    }

    private initDropZone(element: HTMLElement) {
        const id = element.getAttribute('id');
        const template = element.getElementsByClassName(
            'c-form__field__dropzone__preview__template'
        )[0];
        removeClass(template, 'c-form__field__dropzone__preview__template');
        const previewTemplate = template.parentElement.innerHTML;
        template.parentElement.removeChild(template);
        const previewsContainer = element.getElementsByClassName(
            'c-form__field__dropzone__preview__wrapper'
        )[0];
        const dropzoneElement = new Dropzone(element, {
            url: '/',
            method: 'POST',
            paramName: id,
            parallelUploads: 20,
            previewTemplate: previewTemplate,
            uploadMultiple: true,
            autoProcessQueue: false,
            previewsContainer: previewsContainer,
            clickable: '.js-c-form__field__dropzone__button',
            acceptedFiles: 'application/pdf',
            init: function () {
                document
                    .getElementsByClassName('js-form-extended-submit')[0]
                    .addEventListener('click', function (e) {
                        const errors = 0;

                        /*$('#project-create-form [data-val-required]').each(function () {
                        if (!validateField($(this))) {
                            errors++;
                        }
                    });

                    if (!validateFiles()) {
                        errors++;
                    }*/

                        if (errors === 0) {
                            dropzoneElement.processQueue();
                        }

                        /*e.preventDefault();
                    e.stopPropagation();*/
                    });
            }
        });
    }
}

export default function form(
    wrapper: HTMLElement,
    options?: FormExtendedOptions
): FormExtended {
    return new FormExtended(wrapper, options);
}
